import { useCallback, useState } from 'react';

export const useModal = <T extends string>(name: T = '' as T) => {
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  return {
    [`isOpen${name}Modal`]: isOpen,
    [`close${name}Modal`]: closeModal,
    [`open${name}Modal`]: openModal,
  } as {
    [key in `isOpen${T}Modal`]: boolean;
  } & {
    [key in `close${T}Modal`]: () => void;
  } & {
    [key in `open${T}Modal`]: () => void;
  };
};
